export const GET_TERMINAL_REQUEST = '[TERMINALS] GET_TERMINAL_REQUEST'
export const GET_TERMINAL_SUCCESS = '[TERMINALS] GET_TERMINAL_SUCCESS'
export const GET_TERMINAL_FAILED = '[TERMINALS] GET_TERMINAL_FAILED'

export const GET_TERMINAL_LIST_REQUEST = '[TERMINALS] GET_TERMINAL_LIST_REQUEST'
export const GET_TERMINAL_LIST_SUCCESS = '[TERMINALS] GET_TERMINAL_LIST_SUCCESS'
export const GET_TERMINAL_LIST_FAILED = '[TERMINALS] GET_TERMINAL_LIST_FAILED'

export const CREATE_TERMINAL_REQUEST = '[TERMINALS] CREATE_TERMINAL_REQUEST'
export const CREATE_TERMINAL_SUCCESS = '[TERMINALS] CREATE_TERMINAL_SUCCESS'
export const CREATE_TERMINAL_FAILED = '[TERMINALS] CREATE_TERMINAL_FAILED'

export const EDIT_TERMINAL_REQUEST = '[TERMINALS] EDIT_TERMINAL_REQUEST'
export const EDIT_TERMINAL_SUCCESS = '[TERMINALS] EDIT_TERMINAL_SUCCESS'
export const EDIT_TERMINAL_FAILED = '[TERMINALS] EDIT_TERMINAL_FAILED'

export const DELETE_TERMINAL_REQUEST = '[TERMINALS] DELETE_TERMINAL_REQUEST'
export const DELETE_TERMINAL_SUCCESS = '[TERMINALS] DELETE_TERMINAL_SUCCESS'
export const DELETE_TERMINAL_FAILED = '[TERMINALS] DELETE_TERMINAL_FAILED'

export const TERMINAL_SEARCH_REQUEST = '[TERMINALS] TERMINAL_SEARCH_REQUEST'
export const TERMINAL_SEARCH_SUCCESS = '[TERMINALS] TERMINAL_SEARCH_SUCCESS'
export const TERMINAL_SEARCH_FAILED = '[TERMINALS] TERMINAL_SEARCH_FAILED'

export const GET_TERMINAL_PROFILE_LIST_REQUEST = '[TERMINALS] GET_TERMINAL_PROFILE_LIST_REQUEST'
export const GET_TERMINAL_PROFILE_LIST_SUCCESS = '[TERMINALS] GET_TERMINAL_PROFILE_LIST_SUCCESS'
export const GET_TERMINAL_PROFILE_LIST_FAILED = '[TERMINALS] GET_TERMINAL_PROFILE_LIST_FAILED'

export const RESET_TERMINAL_FORM = '[TERMINALS] RESET_TERMINAL_FORM';
